<div class="wd-100 ht-100 flex-col-container">
        <div class="flex-row-center m-t25 prop-container__header B">            
            <span class="m-r6">{{deleteType==='Client'?"Remove":"Delete"}}</span> {{deleteType}}
        </div>
        <div class="flex-col-center">
            <span class="font18 m-t25 m-lr-25">Do you want to <span>{{deleteType==='Client'?"Remove":"Delete"}}</span> this {{deleteType | lowercase}}?</span>                   
            <span class="blueText18 m-15">{{name}}</span>   
            <span *ngIf="deleteType==='Client'" class="red-text font16 m-t25 m-l20">Removing this client will result in removing all it's accounts and cashflows from the plan.</span> 
            
        </div>
        <div class="flex-row-end m-t25 m-tb5 p-r25" >            
            <button mat-raised-button color="basic" (click)="closeDialog()" class="m-l10">Cancel</button>
            <button mat-raised-button color="primary" (click)="delete()" class="m-l10"><span>{{deleteType==='Client'?"Remove":"Delete"}}</span></button>                    
        </div>    
</div>